import { combineEpics, type Epic } from 'redux-observable';
import { filter, mergeMap } from 'rxjs';
import { request } from '@/core';
import { openSnackbar } from '@/core/features/snackbar';
import { updateEventMatchScoreRequest } from '@/api/events';
import i18n from '@/i18n';
import { updateEventMatchScore, setCurrentMatchScore } from '../actions';

const updateEventMatchScoreEpic: Epic = (action$) =>
  action$.pipe(
    filter(updateEventMatchScore.match),
    request(
      ({ payload }) => updateEventMatchScoreRequest(payload),
      updateEventMatchScore,
    ),
  );

const updateEventMatchScoreSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(updateEventMatchScore.succeeded.match),
    mergeMap(({ payload: { data } }) => [
      setCurrentMatchScore(data),
      openSnackbar({
        snackbarType: 'success',
        snackbarMessage: i18n.t('UPDATE_EVENT_MATCH_SCORE_SUCCESS'),
      }),
    ]),
  );

export default combineEpics(
  updateEventMatchScoreEpic,
  updateEventMatchScoreSucceededEpic,
);
